<template>
<!-- 和download页的区别是，识别出机型直接打开应用市场 -->
  <div class="download-container">
    <div class="download">
      <div class="logo">
        <img :src="require('@/assets/images/logo/logo2.jpg')" alt="" />
      </div>
      <div class="btn" @click="toDownload">{{name}}</div>
      <div class="footer-bg">
        <img :src="require('@/assets/images/download/bg.png')" alt="" />
      </div>
      <div class="mask" v-if="showGuide">
        <div class="guide">
          <img :src="require('@/assets/images/download/guide.png')" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Download",
  data() {
    return {
      showGuide: false,
      name:`立即下载${process.env.VUE_APP_APP_NAME}客户端`
    };
  },
  methods: {
    judgeBrand(sUserAgent) {
      var isIphone = sUserAgent.match(/iphone/i) == "iphone";
      var isHuawei = sUserAgent.match(/huawei/i) == "huawei";
      var isHonor = sUserAgent.match(/honor/i) == "honor";
      var isOppo = sUserAgent.match(/oppo/i) == "oppo";
      var isOppoR15 = sUserAgent.match(/pacm00/i) == "pacm00";
      var isVivo = sUserAgent.match(/vivo/i) == "vivo";
      var isXiaomi = sUserAgent.match(/mi\s/i) == "mi ";
      var isXiaomi2s = sUserAgent.match(/mix\s/i) == "mix ";
      var isRedmi = sUserAgent.match(/redmi/i) == "redmi";
      var isSamsung = sUserAgent.match(/sm-/i) == "sm-";

      if (isIphone) {
        return 'iphone';
      } else if (isHuawei || isHonor) {
        return 'huawei';
      } else if (isOppo || isOppoR15) {
        return 'oppo';
      } else if (isVivo) {
        return 'vivo';
      } else if (isXiaomi || isRedmi || isXiaomi2s) {
        return 'xiaomi';
      } else if (isSamsung) {
        return 'samsung';
      } else {
        return 'default';
      }
    },

    browserVersions() {

      var u = navigator.userAgent, app = navigator.appVersion;

      return {//移动终端浏览器版本信息

        trident: u.indexOf('Trident') > -1, //IE内核

        presto: u.indexOf('Presto') > -1, //opera内核

        webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核

        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核

        mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //是否为移动终端

        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端

        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器

        iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器

        iPad: u.indexOf('iPad') > -1, //是否iPad

        webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
      }
    },

    toDownload() {
      let u = navigator.userAgent;
      let isWechat = /MicroMessenger/gi.test(u.toLowerCase());
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || this.browserVersions().android; //android终端
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || this.browserVersions().iPhone || this.browserVersions().iPad || this.browserVersions().ios; //ios终端

      var brand = this.judgeBrand(navigator.userAgent.toLowerCase()); 
      /* 判断是否是在微信浏览器中 */
      if (isWechat) {
        this.showGuide = true;
      }else if(brand=='iphone'){
        window.open("https://apps.apple.com/cn/app/%E4%B8%89%E5%86%9C%E5%8F%B7/id1384791559", "_blank");
      }else if(brand=='huawei'){
        window.open("https://appgallery.huawei.com/app/C101159519?source=qrCodeShare&referrer=PCWebAG&callType=SHARE&shareTo=qrcode&shareFrom=appmarket&reportEventLabel=apprankingpage", "_blank");
      } else if(brand=='xiaomi'){
        window.open("http://app.xiaomi.com/detail/896342", "_blank");
      } else if(brand=='vivo'){
        window.open("https://h5coml.vivo.com.cn/h5coml/appdetail_h5/browser_v2/index.html?appId=2400108&resource=301&source=7", "_blank");
      }  else if (isAndroid) {
        window.open("https://sj.qq.com/appdetail/com.tj.farmerdaily?fromcase=70051&g_f=1182517&scenevia=XQYFX&from_wxz=1", "_blank");
      } else if (isIOS) {
        // window.open("https://itunes.apple.com/cn/app/id1431738308", "_blank");
      } else {
        // window.open("https://appvideo.xtol.cn/download/xtol.apk", "_blank");
      }
    },
  },
  created() {
    var brand = this.judgeBrand(navigator.userAgent.toLowerCase());
    let isWechat = /MicroMessenger/gi.test(navigator.userAgent.toLowerCase());
    if(brand=='iphone'){
      window.open("https://apps.apple.com/cn/app/%E4%B8%89%E5%86%9C%E5%8F%B7/id1384791559", "_blank");
    }else if(brand=='huawei'){
      window.open("https://appgallery.huawei.com/app/C101159519?source=qrCodeShare&referrer=PCWebAG&callType=SHARE&shareTo=qrcode&shareFrom=appmarket&reportEventLabel=apprankingpage", "_blank");
    } else if(brand=='xiaomi'){
      window.open("http://app.xiaomi.com/detail/896342", "_blank");
    } else if(brand=='vivo'){
      window.open("https://h5coml.vivo.com.cn/h5coml/appdetail_h5/browser_v2/index.html?appId=2400108&resource=301&source=7", "_blank");
    } else{
      window.open("https://sj.qq.com/appdetail/com.tj.farmerdaily?fromcase=70051&g_f=1182517&scenevia=XQYFX&from_wxz=1", "_blank");
      

    }

    /* 推广下载地址二维码 */
    //https://newapp2.farmer.com.cn/api/member/anonymous/amc/createQrCodeImage?codeStr=https%3A//newapp2.farmer.com.cn/share/%23/qrcode
  },
};
</script>
<style lang="scss" scoped>
.download-container {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  .download {
    position: relative;
    width: 100%;
    height: 100%;
    // min-height: 188vw;
    background-color: #fff;
    // background-image: url(~@/assets/images/download/download.jpg);
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: center top;
    .logo {
      position: absolute;
      top: 30vh;
      width: 100%;
      text-align: center;
      img {
        width: 150px;
      }
    }
    .btn {
      font-size: 19px;
      color: #fff;
      font-weight: 900;
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
      top: 59.6vh;
      z-index: 2;
      width: 67%;
      height: 9vw;
      text-align: center;
      line-height: 9vw;
      border-radius: 5px;
      background-image: linear-gradient(to bottom, #c3bdbd, #8f8586, #c3bdbd);
    }
    .footer-bg {
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 1;
      width: 100%;
      height: auto;
      img {
        display: block;
        width: 100%;
      }
    }
    .mask {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 9;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.7);
      .guide {
        position: absolute;
        right: 18px;
        top: 5px;
        img {
          display: block;
          height: 180px;
        }
      }
    }
  }
}
@media screen and (min-width: 750px) {
  .download-container {
    .download {
      min-height: 1410px;
      .btn {
        top: 865px;
        height: 67.5px;
      }
    }
  }
}
</style>